import $ from 'jquery';
$(document).ready(function () {
    $('.list_posts_load_more').click(function (e) {
        e.preventDefault();
        let sectionElem = $(this).parents('section');
        let SelectPostType = $(sectionElem).find('input[name=SelectPostType]').val();
        let filterBy = $(sectionElem).find('input[name=filterBy]').val();
        let filterBlogCategory = $(sectionElem).find('input[name=filterBlogCategory]').val();
        let filterBlogAuthor = $(sectionElem).find('input[name=filterBlogAuthor]').val();
        let filterResearchTopic = $(sectionElem).find('input[name=filterResearchTopic]').val();
        let filterResearchAuthor = $(sectionElem).find('input[name=filterResearchAuthor]').val();
        let pageNumber = $(sectionElem).find('input[name=pageNumber]').val();
        let numberOfPosts = $(sectionElem).find('input[name=numberOfPosts]').val();
        let currentPostId = $(sectionElem).find('input[name=currentPostId]').val();
        let nextPageNumber = parseInt(pageNumber) + 1;
        $(sectionElem).find('input[name=pageNumber]').val(nextPageNumber);
        let ajaxurl = '/wp-json/macs/v1/list-posts?SelectPostType=' + encodeURIComponent(SelectPostType) + '&filterBy=' + encodeURIComponent(filterBy) + '&filterBlogCategory=' + encodeURIComponent(filterBlogCategory) + '&filterBlogAuthor=' + encodeURIComponent(filterBlogAuthor) + '&filterResearchTopic=' + encodeURIComponent(filterResearchTopic) + '&filterResearchAuthor=' + encodeURIComponent(filterResearchAuthor) + '&pageNumber=' + encodeURIComponent(nextPageNumber) + '&numberOfPosts=' + encodeURIComponent(numberOfPosts) + '&currentPostId=' + encodeURIComponent(currentPostId);
        $.ajax({
            type: 'GET',
            url: ajaxurl,
            success: function (response, textStatus, jqXHR) {
                if (response.response !== '') {
                    $(sectionElem).find('.box-content').append(response.response);
                }
                else {
                    $(sectionElem).find('.content-more').hide();
                }
            }
        });
    });
});
